var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionTraderEventInfo } from "./actionTraderEventInfo";
var initial = {
    reward: [],
    trade: [],
};
export var reducerTraderEventInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionTraderEventInfo.Received:
            if (action.trader && action.trader.trade && action.trader.reward) {
                return __assign({}, state, { reward: action.trader.reward, trade: action.trader.trade });
            }
            break;
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/reducerTraderEventInfo.ts
// module id = 2983
// module chunks = 3